import { FC } from "react";
import { GraphItem } from "../@types/common";
interface GraphProps {
  items: GraphItem[];
}
const Graph: FC<GraphProps> = ({ items }: GraphProps) => {
  return (
    <div className="flex justify-between rounded-sm border border-x-[0.5px] border-lightGrey bg-lightGrey text-darkBlue mb-2">
      {items.map((item, i) => {
        return (
          <div
            key={i}
            className={`h-l rounded-sm m-[0.5px] ${item.color}`}
            style={{ width: item.percent + "%" }}
          ></div>
        );
      })}
    </div>
  );
};
export default Graph;